import { render, staticRenderFns } from "./AperturasTotales.vue?vue&type=template&id=4b1f0743"
import script from "./AperturasTotales.vue?vue&type=script&lang=js"
export * from "./AperturasTotales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports